import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_2 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_3 = { class: "d-flex flex-stack flex-wrap" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = { class: "text-dark fw-bolder fs-3" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle ms-2 text-primary"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync-alt" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "text-muted fw-bold fs-7"
}
const _hoisted_11 = {
  key: 1,
  class: "text-muted fw-bold fs-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.widgets.monthlyOrdersSum.title")) + " ", 1),
              (_ctx.sumData && _ctx.sumData.branch)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " [" + _toDisplayString(_ctx.sumData.branch.name.replace("Sushi Eden - ", "")) + "] ", 1))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                : (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
                    type: "button",
                    class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                  }, _hoisted_9))
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([`text-${_ctx.chartColor}`, "fw-bolder fs-3"])
          }, " $" + _toDisplayString(_ctx.sumData && _ctx.sumData.list
                ? _ctx.StringUtils.formatAmount(
                    _ctx.sumData.list.reduce((sum, current) => sum + current.sum, 0)
                  )
                : 0), 3)
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Date Period "))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.getDateRange), 1))
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-7-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "area",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}